import PropTypes from 'prop-types';

// This data is created by
// landing/app/controllers/video_editor_controllers.rb

const videoEditorPayloadType = PropTypes.shape({
  show_video_subscriptions: PropTypes.bool,
});

export default videoEditorPayloadType;
